import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationReleaseGet = {
    path: "/release",
    method: ERouteHttpVerb.GET
};
export { routeLocationReleaseGet };
